import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "ml-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_DasTwoDeclaringCard = _resolveComponent("DasTwoDeclaringCard")!
  const _component_DasTwoBeneficiariesCard = _resolveComponent("DasTwoBeneficiariesCard")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_DeclarationManager = _resolveComponent("DeclarationManager")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-2 pr-0 pb-1",
    style: _normalizeStyle(_ctx.$vuetify.display.mobile ? 'width: 100vw;' : '')
  }, {
    default: _withCtx(() => [
      (!_ctx.$vuetify.display.mobile)
        ? (_openBlock(), _createBlock(_component_v_window, {
            key: 0,
            modelValue: _ctx.globalStep,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.globalStep) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_window_item, { value: 0 }, {
                default: _withCtx(() => [
                  (_ctx.loading)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 0,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex justify-center align-center"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_progress_circular, {
                                indeterminate: "",
                                color: "primary"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "mt-2 mb-4 d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "6",
                              class: "d-flex align-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn_back, {
                                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.back()), ["stop"]))
                                }),
                                _createElementVNode("div", _hoisted_1, [
                                  _cache[5] || (_cache[5] = _createElementVNode("h3", null, "DAS2", -1)),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.formatDate(_ctx.startDate) + " - " + _ctx.formatDate(_ctx.endDate)), 1)
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "6",
                              class: "d-flex justify-end pr-4"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.globalStep >= 1)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 0,
                                      rounded: "",
                                      class: "mr-1",
                                      elevation: "0",
                                      disabled: _ctx.globalStep <= 0,
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.globalStep--)),
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                                        _createTextVNode("Précédent")
                                      ])),
                                      _: 1
                                    }, 8, ["disabled"]))
                                  : _createCommentVNode("", true),
                                (_ctx.globalStep < 1)
                                  ? (_openBlock(), _createBlock(_component_v_btn, {
                                      key: 1,
                                      rounded: "",
                                      elevation: "0",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.globalStep++)),
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                                        _createTextVNode("Suivant")
                                      ])),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "pr-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_DasTwoDeclaringCard, { declaring: _ctx.declaring }, null, 8, ["declaring"]),
                                _createVNode(_component_DasTwoBeneficiariesCard, {
                                  items: _ctx.beneficiaries,
                                  loading: _ctx.loading,
                                  companyId: _ctx.companyId,
                                  startDate: _ctx.startDate,
                                  endDate: _ctx.endDate,
                                  isIncomingOutgoingPaymentAccountingType: 
                                        _ctx.accountingType === 'INCOMING_OUTGOING_PAYMENT'
                                    
                                }, null, 8, ["items", "loading", "companyId", "startDate", "endDate", "isIncomingOutgoingPaymentAccountingType"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ], 64))
                ]),
                _: 1
              }),
              _createVNode(_component_v_window_item, { value: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          (_ctx.globalStep === 1)
                            ? (_openBlock(), _createBlock(_component_DeclarationManager, {
                                key: 0,
                                propsCerfaNumber: _ctx.cerfaNumber,
                                propsStartDate: _ctx.startDate,
                                propsEndDate: _ctx.endDate,
                                assistDasTwoMode: true,
                                assistDasTwoDeclaring: _ctx.declaring,
                                assistDasTwoBeneficiaries: _ctx.beneficiariesToAdd,
                                onBack: _cache[3] || (_cache[3] = ($event: any) => (_ctx.globalStep--))
                              }, null, 8, ["propsCerfaNumber", "propsStartDate", "propsEndDate", "assistDasTwoDeclaring", "assistDasTwoBeneficiaries"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["style"]))
}